const slugifyExportLabel = (label = '') =>
  label
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u2014\u2013·]/g, '-')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const buildImageFileName = (item, filePrefix = 'solution-demo') => {
  const slug = item.fileNameSlug || slugifyExportLabel(item.label);
  return `${filePrefix}-${slug}.png`;
};
